const API = {
  catalogMenu: {
    APIurl: '/api/Menu/',
    idField: '',
  },
  catalogs: {
    APIurl: '/api/Catalog/',
    idField: '',
  },
  projects: {
    APIurl: '/api/Catalog/Project/',
    idField: 'projectId',
  },
  lands: {
    APIurl: '/api/Catalog/Land/',
    idField: 'landId',
  },
  users: {
    APIurl: '/api/Catalog/UserClient/',
    idField: 'userClientId',
  },
  login: {
    APIurl: '/api/Auth/Login',
    SocialUrl: '/api/Auth/SocialLogin',
    idField: '',
  },
  registerUser: {
    APIurl: '/api/Auth/Register',
    ConfirmEmailUrl: '/api/Auth/ConfirmEmail?userId=#uid&code=#cd',
    idField: '',
  },
}

export default API
